import { FULL_MARKETING_GALLERY_IMAGES } from "../../constants/productGalleryImages";

export interface Product {
  id: string;
  name: string;
  price: number;
  image_paths: string[];
  description: string;
  details: string;
}

/** Primary catalog bundle for upper-limb home practice. */
export const products: Product[] = [
  {
    id: "00",
    name: "mRehab Starter Kit",
    price: 35.0,
    image_paths: [
      "/images/product/mug-and-bowl-still-image.jpeg",
      ...FULL_MARKETING_GALLERY_IMAGES.filter(
        (p) => p !== "/images/product/mug-and-bowl-still-image.jpeg"
      ),
    ],
    description:
      "Printed practice accessories plus app access for structured upper-limb sessions at home after stroke. Sensor feedback on your phone, optional 3D-printed tools, and a path that complements your clinicians.",
    details:
      "Includes printed accessories for use with the mRehab app and a quick start guide. Fulfillment timing and availability vary by region; see checkout or contact us for details.",
  },
];
